import { Component } from '@angular/core';
import { ActionSheetController, ToastController, Platform, LoadingController, IonicPage, NavController, NavParams, App } from 'ionic-angular';
import { LoginPage } from '../login/login';
import { RestProvider } from '../../providers/rest/rest';
import { HttpClient } from '@angular/common/http';
import { DataProvider } from '../../providers/data/data';


@IonicPage()
@Component({
  selector: 'page-register',
  templateUrl: 'register.html',
})
export class RegisterPage {
  private name: any;
  private email: any;
  private password: any;
  private password2: any;
  private companyId: any;
  private jobId: any;
  private image: any;
  public companys = [];
  private jobs = [];
  images = [];
  ref: any;
  constructor(public navCtrl: NavController, public navParams: NavParams,
    private rest: RestProvider,
    private http: HttpClient,
    private loadingController: LoadingController,
    private toastCtrl: ToastController,
    private actionSheetController: ActionSheetController,
    private plt: Platform,
    private data: DataProvider,
    public app: App,) {
  }

  ionViewDidLoad() {
    document.getElementById('backmenu').style.display = 'block';
    //this.rest.companys().subscribe(res => {
     // console.log(res);
    //});
    this.rest.companys().subscribe(res => {
      this.companys = res;
    });

  }
  showToast(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'top',
      duration: 5000,
      cssClass: "toast-success"
    });
    toast.present();
  }
  showToast1(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'middle',
      duration: 5000,
      cssClass: "toast-unsuccess"
    });
    toast.present();
  }
  getJobs(event: any) {
    this.rest.jobs(this.companyId).subscribe(res => {
      this.jobs = res;
    });
  }

  backtologin(){
    var nav = this.app.getRootNavs();
    nav[0].setRoot(LoginPage);
  }
  //checkregister(){
  //  this.navCtrl.push(LoginPage)
  //}
  checkregister(){
    if(this.name == null){
      this.showToast1('Нэр бичээгүй байна.');
      return;
    } else if(this.email == null) {
      this.showToast1('И-мэйл бичээгүй байна.');
      return;
    } else if(this.companyId == null){
      this.showToast1('Компани сонгоогүй байна.');
      return;
    } else if(this.password == null){
      this.showToast1('Нууц үг бичээгүй байна.');
      return;
    } else if(this.jobId == null){
      this.showToast1('Албан тушаал сонгоогүй байна.');
      return;
    } else if(this.password != this.password2) {
      this.showToast1('Нууц үг зөрж байна.');
      return;
    }

    this.rest.register(this.name, this.email, this.password, this.companyId, this.jobId, "").subscribe(res => {
      if(res.msg == null) {
        this.showToast1('Та мэдээллээ бүрэн оруулна уу.');
      } else if(res.msg == 'ok') {
        this.showToast('Амжилттай бүртгүүллээ. Баталгаажтал түр хүлээнэ үү.');
        var nav = this.app.getRootNavs();
        nav[0].setRoot(LoginPage);
      } else {
        this.showToast1('Бүртгэлтэй хэрэглэгч байна.');
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/register/register.ts